import React, { useState, useEffect } from "react";
import MainMap from "../OrderDetails/map";
import useSimpleReactValidator from "../../Hooks/useSimpleReactValidator";
import axios from "axios";
import { apiCall_domain } from "../api";
import Header from "../header";
import PulseLoader from "react-spinners/PulseLoader";
const NewAddresses = (props) => {
  const [values, setValues] = useState({
    title: "",
    address: "",
    name: "",
    address_phone: "",
    map: "",
  });
  const [loading, setLoading] = useState(false);
  const [city, setCity] = useState();
  const [showmap, setShowmap] = useState(false);
  useEffect(() => {
    const splash = JSON.parse(localStorage.getItem("splash")).customer_info;
    setCity(splash.city);
  }, []);
  useEffect(() => {
    if (props?.match?.params?.id) {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .get(`${apiCall_domain}/customer/user/addresses?1`, {
          headers: headers,
        })
        .then((res) => {
          const address = res.data.data.find(
            (address) => address.id === parseInt(props?.match?.params?.id),
          );
          setValues(address);
          setValues({
            title: address.title,
            address_phone: address.address_phone,
            address: address.address,
            map: { lat: address.lat, lng: address.lng },
          });
        });
    }
  }, [props?.match?.params?.id]);
  const [validator, forceUpdate] = useSimpleReactValidator({
    className: " fieldRequired danger",
    messages: {
      required: "این فیلد نباید خالی باشد",
    },
    validators: {
      regexFormat: {
        message: "لطفا یک شماره موبایل معتبر وارد کنید",
        rule: (val, params, validator) => {
          return validator.helpers.testRegex(val, "^(\\+98|0)?9\\d{9}$");
        },
      },
    },
    autoForceUpdate: true,
  });

  const handleShowmap = (condition) => {
    setShowmap(condition);
  };
  const changeValues = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };
  const changeMap = (latlng) => {
    setValues({
      ...values,
      map: latlng,
    });
  };
  const handleSaveaddress = () => {
    if (validator.allValid()) {
      setLoading(true);
      const Data = {
        lat: localStorage.getItem("lat"),
        lng: localStorage.getItem("lng"),
        address: values.address,
        address_phone: values.address_phone,
        title: values.title,
        city_id: city.id,
      };
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      if (props?.match?.params?.id) {
        Data["id"] = props?.match?.params?.id;
        axios
          .post(`${apiCall_domain}/customer/user/addresses/update`, Data, {
            headers: headers,
          })
          .finally(() => {
            setLoading(false);
            if (props.afterSuccess) {
              props.afterSuccess();
            } else {
              props.history.goBack();
            }
          });
      } else {
        axios
          .post(`${apiCall_domain}/customer/user/addresses`, Data, {
            headers: headers,
          })
          .then((res) => {
            if (props.afterSuccess) {
              props.afterSuccess();
            } else {
              props.history.goBack();
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
    } else {
      validator.showMessages();
      forceUpdate();
    }
  };
  return (
    <>
      {showmap ? (
        <MainMap handleShowmap={() => handleShowmap()} changeMap={changeMap} />
      ) : (
        <>
          <Header showSearchBar={true} title={"افزودن ادرس"} />
          <section className="NewAddressesLightlayout">
            <div className="NewAddresses">
              <div
                className="DetailMap"
                onClick={() => {
                  handleShowmap(true);
                }}
              >
                <img
                  src="/public/assets/map.jpg"
                  className="Mapbody"
                  alt="map"
                />
                <img
                  src="/public/assets/icons/locationInMap.svg"
                  className="LocationMap"
                  alt="location"
                />
                <span>موقعیت آدرس را روی نقشه مشخص کنید</span>
              </div>
              <div className="mapField">
                {validator.message("map", values.map, "required", {
                  messages: { required: "موقعیت مکانی را روی نقشه نشان دهید" },
                })}
              </div>
              <div className="fields">
                <div className="field">
                  <input
                    className="input"
                    name="title"
                    value={values?.title}
                    placeholder="عنوان آدرس : مثل خانه ، شرکت"
                    onChange={changeValues}
                  />
                  {validator.message("title", values?.title, "required")}
                </div>
                <div className="field">
                  <input
                    type="text"
                    value={city?.name}
                    className="addAddressCity"
                    disabled
                  />
                </div>
                <div className="field">
                  <textarea
                    value={values?.address}
                    onChange={changeValues}
                    name="address"
                    className="input"
                    placeholder="آدرس کامل: خیابان، کوچه ، پلاک ، طبقه ، واحد"
                  ></textarea>
                  {validator.message("address", values?.address, "required")}
                </div>
                <div className="field">
                  <input
                    value={values?.address_phone}
                    onChange={changeValues}
                    name="address_phone"
                    className="input"
                    placeholder="شماره تماس"
                  />
                  {validator.message(
                    "address_phone",
                    values?.address_phone,
                    "required|regexFormat",
                  )}
                </div>
              </div>
            </div>
            <button
              onClick={() => {
                handleSaveaddress();
              }}
              className="btn btn--newaddress"
            >
              {loading ? (
                <PulseLoader color="#fff" size={10} />
              ) : props?.match?.params?.id ? (
                "بروزرسانی آدرس"
              ) : (
                "ثبت آدرس"
              )}
            </button>
          </section>
        </>
      )}
    </>
  );
};
export default NewAddresses;
